import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import {
  Grid,
  TextField,
  Checkbox,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Box,
} from '@material-ui/core';
import DatePicker from 'react-datepicker';
import CancelIcon from '@material-ui/icons/Cancel';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { green, red } from '@material-ui/core/colors';
import { ErrorMessage } from 'components';
import {
  RESPONSE_STATUS_VALUES,
  CAR_TAB_RESPONSE_STATUSES,
  FIRE_AND_INJURY_TAB_RESPONSE_STATUSES,
} from 'const';
import styles from 'styles/admin-detail.module.scss';
import { format, parseISO } from "date-fns"
import { currentUserSelector } from "store/current_user"
import { isPermitted, convertDateSeparatorOrHyphen } from 'utils/utils';

const useStyles = makeStyles(() => ({
  root: {},
  selecter: {
    height: 20,
  },
}));

const BasicInformation = (props) => {
  const classes = useStyles();
  const { insuranceType, basicInfo, basicInformationInputFormik, lockedBy } = props;

  const [responseStatusOptionList, setResponseStatusOptionList] = useState([]);
  useEffect(() => {
    if (insuranceType === 1) {
      setResponseStatusOptionList(CAR_TAB_RESPONSE_STATUSES);
    } else if (insuranceType === 2 || insuranceType === 3) {
      setResponseStatusOptionList(FIRE_AND_INJURY_TAB_RESPONSE_STATUSES);
    }
  }, [insuranceType]);

  const currentUser = useSelector(currentUserSelector)

  // プラスボタン用コールバック
  const addCallHistory = () => {
    // 本日日付を作成
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = ('00' + (today.getMonth() + 1)).slice(-2);
    const dd = ('00' + today.getDate()).slice(-2);

    // 本日日付で履歴を追加
    basicInformationInputFormik.setFieldValue(
      'callHistories',
      [ ...basicInformationInputFormik.values.callHistories, {
        id: null,
        outboundDate: yyyy + '-' + mm + '-' + dd,
        memo: '',
      } ]
    );
  };

  // 削除ボタン用コールバック
  const deleteHistory = (index) => {
    basicInformationInputFormik.setFieldValue(
      'callHistories',
      basicInformationInputFormik.values.callHistories.filter((_, i) => i !== index)
    );
  };

  const getCallHistoryTableRowElement = () => {
    const result = [];
    for (
      let index = 0;
      index < basicInformationInputFormik.values.callHistories.length;
      index++
    ) {
      result.push(
        <TableRow key={index}>
          <TableCell
            align='left'
            style={{
              width: '5%',
            }}
          >
            <Chip label={index + 1 + '回目'} />
          </TableCell>
          <TableCell
            align='left'
            style={{
              width: '15%',
            }}
          >
            <label className={styles.callDateTitle}>コール日</label>
            <DatePicker
              id={`callHistories[${index}].outboundDate`}
              className={
                !!(
                  basicInformationInputFormik.touched.callHistories &&
                  basicInformationInputFormik.touched.callHistories.hasOwnProperty(
                    index
                  ) &&
                  basicInformationInputFormik.touched.callHistories[index] &&
                  basicInformationInputFormik.touched.callHistories[index]
                    .outboundDate &&
                  basicInformationInputFormik.errors.callHistories &&
                  basicInformationInputFormik.errors.callHistories.hasOwnProperty(
                    index
                  ) &&
                  basicInformationInputFormik.errors.callHistories[index] &&
                  basicInformationInputFormik.errors.callHistories[index]
                    .outboundDate
                )
                  ? styles.errorDatePicker
                  : styles.datePicker
              }
              selected={
                basicInformationInputFormik.values.callHistories[index]
                  .outboundDate
                  ? parseISO(basicInformationInputFormik.values.callHistories[index]
                      .outboundDate) || null
                  : null
              }
              maxDate={new Date('2999/12/31')}
              minDate={new Date('2000/01/01')}
              onChange={(date) => {
                basicInformationInputFormik.setFieldTouched(
                  `callHistories[${index}].outboundDate`, true
                );
                basicInformationInputFormik.setFieldValue(
                  `callHistories[${index}].outboundDate`,
                  date ? format(date, 'yyyy-MM-dd') : ''
                );
              }}
              onBlur={basicInformationInputFormik.handleBlur}
              dateFormat='yyyy/MM/dd'
              placeholderText='年/月/日'
              isClearable={isPermitted(currentUser, lockedBy)}
              disabled={!isPermitted(currentUser, lockedBy)}
            />
            <ErrorMessage
              touched={
                basicInformationInputFormik.touched.callHistories &&
                basicInformationInputFormik.touched.callHistories.hasOwnProperty(
                  index
                ) &&
                basicInformationInputFormik.touched.callHistories[index] &&
                basicInformationInputFormik.touched.callHistories[index]
                  .outboundDate
              }
              error={
                basicInformationInputFormik.errors.callHistories &&
                basicInformationInputFormik.errors.callHistories.hasOwnProperty(
                  index
                ) &&
                basicInformationInputFormik.errors.callHistories[index] &&
                basicInformationInputFormik.errors.callHistories[index]
                  .outboundDate
              }
            />
          </TableCell>
          <TableCell
            align='left'
            style={{
              width: '75%',
            }}
          >
            <TextField
              label='メモ'
              type='text'
              {...basicInformationInputFormik.getFieldProps(`callHistories[${index}].memo`)}
              style={{
                width: '100%',
              }}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={!isPermitted(currentUser, lockedBy)}
              error={
                !!(
                  basicInformationInputFormik.touched.callHistories &&
                  basicInformationInputFormik.touched.callHistories.hasOwnProperty(
                    index
                  ) &&
                  basicInformationInputFormik.touched.callHistories[index] &&
                  basicInformationInputFormik.touched.callHistories[index]
                    .memo &&
                  basicInformationInputFormik.errors.callHistories &&
                  basicInformationInputFormik.errors.callHistories.hasOwnProperty(
                    index
                  ) &&
                  basicInformationInputFormik.errors.callHistories[index] &&
                  basicInformationInputFormik.errors.callHistories[index].memo
                )
              }
            />
            <ErrorMessage
              touched={
                basicInformationInputFormik.touched.callHistories &&
                basicInformationInputFormik.touched.callHistories.hasOwnProperty(
                  index
                ) &&
                basicInformationInputFormik.touched.callHistories[index] &&
                basicInformationInputFormik.touched.callHistories[index].memo
              }
              error={
                basicInformationInputFormik.errors.callHistories &&
                basicInformationInputFormik.errors.callHistories.hasOwnProperty(
                  index
                ) &&
                basicInformationInputFormik.errors.callHistories[index] &&
                basicInformationInputFormik.errors.callHistories[index].memo
              }
            />
          </TableCell>
          <TableCell
            align='center'
            style={{
              width: '5%',
            }}
          >
            <IconButton
              aria-label='deleteCallHistory'
              onClick={() => deleteHistory(index)}
              style={{
                color: isPermitted(currentUser, lockedBy) ? red[800] : 'gray'
              }}
              disabled={!isPermitted(currentUser, lockedBy)}
            >
              <CancelIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    }
    return result;
  };

  return (
    <>
      <label className={styles.boxTitle}>基本情報</label>
      <Box border={1} className={styles.roundBox}>
        <Grid container spacing={5}>
          <Grid item xs={3}>
            <div className={styles.item}>
              <p className={styles.labelTop}>受付番号</p>
              <p className={styles.text}>{basicInfo?.applyId || '-'}</p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.item}>
              <p className={styles.labelTop}>
                <span className={styles.LineStyle}>LINE</span>チャット
              </p>
              <p className={styles.text}>{basicInfo?.lineId ? '可' : '不可'}</p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.item}>
              <p className={styles.labelTop}>受付日時</p>
              <p className={styles.text}>{convertDateSeparatorOrHyphen(basicInfo?.createdAt)}</p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.item}>
              <p className={styles.labelTop}>最終更新日時</p>
              <p className={styles.text}>{convertDateSeparatorOrHyphen(basicInfo?.updatedAt)}</p>
            </div>
          </Grid>
        </Grid>
      </Box>
      <div className={styles.airBox}>
        <Grid container spacing={5}>
          <Grid item xs={3}>
            <div className={styles.item}>
              <p className={styles.labelTop}>ステータス</p>
              <Select
                fullWidth
                className={classes.selecter}
                id='status'
                value={basicInformationInputFormik.values.responseStatus || ''}
                disabled={!isPermitted(currentUser, lockedBy)}
                onClick={(event) => {
                  if (!isPermitted(currentUser, lockedBy)) return;
                  basicInformationInputFormik.setFieldValue(
                    'responseStatus',
                    event.target.value
                  )
                }}
                error={
                  !!(
                    basicInformationInputFormik.touched.responseStatus &&
                    basicInformationInputFormik.errors.responseStatus
                  )
                }
              >
                {responseStatusOptionList.map((value) => (
                  <MenuItem key={value} value={value}>
                    {RESPONSE_STATUS_VALUES[String(value)]}
                  </MenuItem>
                ))}
              </Select>
              <ErrorMessage
                touched={basicInformationInputFormik.touched.responseStatus}
                error={basicInformationInputFormik.errors.responseStatus}
              />
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.item}>
              <span className={styles.labelTop}>要SMS送信</span>
              <Checkbox
                checked={
                  basicInformationInputFormik.values.isSmsSendingRequired ===
                  '1'
                }
                color='primary'
                disabled={!isPermitted(currentUser, lockedBy)}
                onClick={() =>
                  basicInformationInputFormik.setFieldValue(
                    'isSmsSendingRequired',
                    basicInformationInputFormik.values.isSmsSendingRequired ===
                      '1'
                      ? '2'
                      : '1'
                  )
                }
              />
            </div>
          </Grid>
        </Grid>
      </div>
      <label className={styles.boxTitle}>
        コール指定有
        <Checkbox
          checked={basicInformationInputFormik.values.callFlg}
          color='primary'
          className={styles.checkbox}
          disabled={!isPermitted(currentUser, lockedBy)}
          onClick={() => {
            basicInformationInputFormik.setFieldValue(
              'callFlg',
              !basicInformationInputFormik.values.callFlg
            );
          }}
        />
      </label>
      <Box border={1} className={styles.roundBox}>
        <Grid container spacing={5}>
          <Grid item xs={2}>
            <div className={styles.item}>
              <p className={styles.labelTop}>コール指定日</p>
              <DatePicker
                id='callDesignatedDate'
                className={
                  !!(
                    basicInformationInputFormik.touched.callDesignatedDate &&
                    basicInformationInputFormik.errors.callDesignatedDate
                  )
                    ? styles.errorDatePicker
                    : styles.datePicker
                }
                selected={
                  basicInformationInputFormik.values.callFlg
                    ? basicInformationInputFormik.values.callDesignatedDate 
                      ? parseISO(basicInformationInputFormik.values.callDesignatedDate) 
                      : null
                    : null
                }
                maxDate={new Date('2999/12/31')}
                minDate={new Date('2000/01/01')}
                onChange={(date) => {
                  basicInformationInputFormik.setFieldTouched('callDesignatedDate', true);
                  basicInformationInputFormik.setFieldValue(
                    'callDesignatedDate',
                    date ? format(date, 'yyyy-MM-dd') : ''
                  );
                }}
                onBlur={basicInformationInputFormik.handleBlur}
                dateFormat='yyyy/MM/dd'
                placeholderText='年/月/日'
                isClearable={isPermitted(currentUser, lockedBy)}
                disabled={!basicInformationInputFormik.values.callFlg || !isPermitted(currentUser, lockedBy)}
              />
              <ErrorMessage
                touched={basicInformationInputFormik.touched.callDesignatedDate}
                error={basicInformationInputFormik.errors.callDesignatedDate}
              />
            </div>
          </Grid>
          <Grid item xs={10}>
            <div className={styles.item}>
              <p className={styles.labelTop}>コール指定時間等</p>
              <TextField
                InputProps={{
                  classes: {
                    root: classes.rootTxt,
                    disabled: classes.disabled,
                  },
                }}
                fullWidth
                disabled={!basicInformationInputFormik.values.callFlg || !isPermitted(currentUser, lockedBy)}
                type={'text'}
                variant='outlined'
                {...basicInformationInputFormik.getFieldProps('callDesignatedTimeAndMemo')}
                value={
                  basicInformationInputFormik.values.callFlg
                    ? basicInformationInputFormik.values
                        .callDesignatedTimeAndMemo
                    : ''
                }
                error={
                  !!(
                    basicInformationInputFormik.touched
                      .callDesignatedTimeAndMemo &&
                    basicInformationInputFormik.errors.callDesignatedTimeAndMemo
                  )
                }
              />
              <ErrorMessage
                touched={
                  basicInformationInputFormik.touched.callDesignatedTimeAndMemo
                }
                error={
                  basicInformationInputFormik.errors.callDesignatedTimeAndMemo
                }
              />
            </div>
          </Grid>
        </Grid>
      </Box>
      <p className={styles.labelTop}>コール履歴</p>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {getCallHistoryTableRowElement()}
            <TableRow key='plus'>
              <TableCell colSpan={4} align='center'>
                <IconButton
                  aria-label='addCallHistory'
                  onClick={addCallHistory}
                  disabled={!isPermitted(currentUser, lockedBy)}
                  style={{
                    color: isPermitted(currentUser, lockedBy) ? green[800] : 'gray'
                  }}
                >
                  <AddCircleIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Grid container spacing={4} className={styles.memoArea}>
        <Grid item xs={6}>
          <div className={styles.item}>
            <p className={styles.labelTop}>メモ(AD)</p>
            <TextField
              fullWidth
              type={'text'}
              variant='outlined'
              disabled={!isPermitted(currentUser, lockedBy)}
              {...basicInformationInputFormik.getFieldProps('memoAD')}
              error={
                !!(
                  basicInformationInputFormik.touched.memoAD &&
                  basicInformationInputFormik.errors.memoAD
                )
              }
            />
            <ErrorMessage
              touched={basicInformationInputFormik.touched.memoAD}
              error={basicInformationInputFormik.errors.memoAD}
            />
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className={styles.item}>
            <p className={styles.labelTop}>メモ(SV)</p>
            <TextField
              fullWidth
              type={'text'}
              variant='outlined'
              disabled={!isPermitted(currentUser, lockedBy)}
              {...basicInformationInputFormik.getFieldProps('memoSV')}
              error={
                !!(
                  basicInformationInputFormik.touched.memoSV &&
                  basicInformationInputFormik.errors.memoSV
                )
              }
            />
            <ErrorMessage
              touched={basicInformationInputFormik.touched.memoSV}
              error={basicInformationInputFormik.errors.memoSV}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default BasicInformation;
